import { Routes, Route } from "react-router-dom";
import GroupDetail from "./GroupDetail";

const GroupsRouter = ({ groups = [], setGroups }) => {
  return (
    <Routes>
      <Route
        path="/:groupId"
        element={<GroupDetail groups={groups} setGroups={setGroups} />}
      />
    </Routes>
  );
};

export default GroupsRouter;
